import { Typography } from '@mui/material';
import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { LaunchpadCard } from 'src/components/ui/LaunchpadCard';
import { object, string } from 'yup';
import { SPVSelector } from '../atomic-components/SPVSelector';

export const validationSchemaIssuer = object({
  cityDetails: string().required('City Details is required'),
});

interface Props {
  disabled: boolean;
}

export const Issuer: FC<Props> = ({ disabled }) => {
  const { t } = useTranslation();

  return (
    <LaunchpadCard title={t('dashboard.assets.addedit.investment.issuer.title')}>
      <Typography variant="body1">{t('dashboard.assets.addedit.investment.issuer.description1')}</Typography>

      <SPVSelector disabled={disabled} />
      <Typography variant="body1">{t('dashboard.assets.addedit.investment.issuer.description2')}</Typography>
    </LaunchpadCard>
  );
};
